import { render, staticRenderFns } from "./MultipleResponse.vue?vue&type=template&id=5afdf4e6"
import script from "./MultipleResponse.vue?vue&type=script&lang=js"
export * from "./MultipleResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports